/**
 * Defines an address.
 */
export default class Address {
    /**
     * Set all attributes.
     * @param {object} address
     */
    constructor(address) {
        this.streetName = address.street_name;
        this.streetNumber = address.street_number;
        this.zipCode = address.zip_code;
        this.city = address.city;
        this.province = address.province;
        this.countryCode = address.country_code;
    }
}
